<template>
	<section class="other_page_banner trade_sec banner_nxt_sec_not_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{ $t('new_ui.personal_send_page.section_banner.title.one') }}
						</h2>
						<h6>
							{{
								$t('new_ui.personal_send_page.section_banner.main_title.one')
							}}
						</h6>
						<p>
							{{ $t('new_ui.personal_send_page.section_banner.paragraph.one') }}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="qrpay send_qrpay">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-3 col-xl-3 col-lg-3 col-md-12">
					<div class="qrpay_lt">
						<img :src="img.image36" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-12 col-xxl-9 col-xl-9 col-lg-9 col-md-12">
					<div class="qrpay_rt send_qrpay">
						<span>{{ $t('new_ui.personal_send_page.qr_pay.label') }}</span>
						<div class="qrpay_rt_txt">
							<h4>
								{{ $t('new_ui.personal_send_page.qr_pay.title.one')
								}}<span>
									{{ $t('new_ui.personal_send_page.qr_pay.title.two') }}</span
								>
							</h4>
							<p>
								{{ $t('new_ui.personal_send_page.qr_pay.paragraph') }}
							</p>
						</div>
						<div class="enjoy_shopping_sec qr-send_desk">
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image34" alt="" />
									<div class="offer_round">1</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_1st.heading',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_1st.paragraph',
											)
										}}
									</p>
								</div>
							</div>

							<!-- <div class="curve_up">
										<img :src="img.image12" alt="" />
									</div> -->

							<div class="enjoy_shopping_inn shoping_mid">
								<div class="enjoy_shopping_box">
									<img :src="img.image2" alt="" />
									<div class="offer_round offer_round2">2</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_2nd.heading',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_2nd.paragraph',
											)
										}}
									</p>
								</div>
							</div>

							<!-- <div class="curve_dwn">
										<img :src="img.image13" alt="" />
									</div> -->

							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image35" alt="" />
									<div class="offer_round">3</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_3rd.heading',
											)
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_send_page.qr_pay.white_box_3rd.paragraph',
											)
										}}
									</p>
								</div>
							</div>
						</div>

						<div class="enjoy_shopping_sec qr-send_mob text-center">
							<div class="enjoy_slider">
								<swiper
									:slides-per-view="1"
									:space-between="30"
									:loop="true"
									:pagination="{
										el: '.swiper-pagination-2',
										clickable: true,
									}"
									:autoplay="{ delay: 2000, disableOnInteraction: false }"
									:breakpoints="{
										0: { slidesPerView: 1 },
										600: { slidesPerView: 1.5 },
										768: { slidesPerView: 2 },
										1000: { slidesPerView: 3 },
										1200: { slidesPerView: 4.5 },
									}"
								>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image34" alt="" />
												<div class="offer_round">1</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_1st.heading',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_1st.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image2" alt="" />
												<div class="offer_round offer_round2">2</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_2nd.heading',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_2nd.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image35" alt="" />
												<div class="offer_round">3</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_3rd.heading',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.personal_send_page.qr_pay.white_box_3rd.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
								</swiper>
								<!-- Move pagination outside swiper -->
								<div class="swiper-pagination-2"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="round_monitor">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="round_monitor_lt">
						<span>{{
							$t('new_ui.personal_send_page.round_monitor.label')
						}}</span>
						<div class="round_monitor_lt_txt">
							<h4>
								{{ $t('new_ui.personal_send_page.round_monitor.title.one') }}
								<span>{{
									$t('new_ui.personal_send_page.round_monitor.title.two')
								}}</span>
							</h4>
							<p>
								{{ $t('new_ui.personal_send_page.round_monitor.paragraph') }}
							</p>
							<div class="starting_to_btn pay_world">
								<a href="/auth/register">{{
									$t('new_ui.personal_send_page.round_monitor.cta_buttons.one')
								}}</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="round_monitor_rt">
						<img :src="img.image37" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="question_sec question_trade">
		<div class="container">
			<div class="row">
				<div class="col-sm-5 question_desk">
					<div class="question_lt">
						<img :src="img.image38" alt="" />
					</div>
				</div>
				<div class="col-sm-5 question_mob">
					<div class="question_lt">
						<img :src="img.image41" alt="" />
					</div>
				</div>
				<div class="col-sm-7">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.personal_send_page.question_trade.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{ $t('new_ui.personal_send_page.question_trade.title.one') }}
									<span>{{
										$t('new_ui.personal_send_page.question_trade.title.two')
									}}</span>
								</h4>
								<p>
									{{
										$t('new_ui.personal_send_page.question_trade.paragraph.one')
									}}
								</p>
								<p>
									{{
										$t('new_ui.personal_send_page.question_trade.paragraph.two')
									}}
								</p>
								<div class="starting_to_btn">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_send_page.question_trade.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="ziga_sec">
		<div class="ziga_lt"><img :src="img.image39" alt="" /></div>
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="ziga_inn">
						<span>{{ $t('new_ui.personal_send_page.ziga_sec.label') }}</span>
						<h4>
							{{ $t('new_ui.personal_send_page.ziga_sec.title.one')
							}}<span>{{
								$t('new_ui.personal_send_page.ziga_sec.title.two')
							}}</span>
						</h4>
						<div class="ziga_btm">
							<div class="ziga_btm_lt">
								<p>
									{{ $t('new_ui.personal_send_page.ziga_sec.paragraph') }}
								</p>
							</div>
							<div class="ziga_btm_rt">
								<a href="#">{{
									$t('new_ui.personal_send_page.ziga_sec.cta_buttons.one')
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ziga_rt ziga_up_desk"><img :src="img.image40" alt="" /></div>
		<div class="ziga_rt ziga_up_mob"><img :src="img.image42" alt="" /></div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_send_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.personal_send_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.personal_send_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_send_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_send_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_send_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_send_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import lockkey from '@/assets/images/sub/lockkey.png';
import mobileqr from '@/assets/images/sub/Mobile QR.png';
import handmobile from '@/assets/images/sub/handmobile.png';
import confirm from '@/assets/images/sub/Confirm.png';
import secure from '@/assets/images/sub/Secure Payment.png';
import curveup from '@/assets/images/sub/Curve Arrow.png';
import curvedwn from '@/assets/images/sub/Curve_dwn.png';
import boymoni from '@/assets/images/sub/boymoni.png';
import worldwide from '@/assets/images/sub/world_wide.png';
import zigalt from '@/assets/images/sub/left_hand.png';
import zigart from '@/assets/images/sub/right_hand.png';
import sendmobdia from '@/assets/images/sub/send_mob_dia.png';
import zigaupmob from '@/assets/images/sub/upperhand_mob.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);

export default {
	data: () => {
		return {
			img: {
				image1: lockkey,
				image2: secure,
				image36: mobileqr,
				image34: handmobile,
				image35: confirm,
				image12: curveup,
				image13: curvedwn,
				image37: boymoni,
				image38: worldwide,
				image39: zigalt,
				image40: zigart,
				image41: sendmobdia,
				image42: zigaupmob,
			},
		};
	},
};
</script>
